import * as React from "react";
import { BlueCircleBtn } from "../../../assets/svg/BlueCircleBtn";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { SvgButton } from "../svg-button/SvgButton";
export var ButtonAddResource = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React.createElement(SvgButton, { name: IdStyles.DefaultRoundBtn, svg: BlueCircleBtn, onClick: onClick },
        React.createElement("div", { className: "flex flex--guts h100" },
            React.createElement(Icon, { icon: IdIcon.PlusIcn, styleId: IdStyles.IconSmall }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonAddResource.tsx
// module id = 888
// module chunks = 3